const ar = {
  welcomeMessage: 'مرحباً بك ',
  home: 'الرئيسية',
  eServices: 'الخدمات الإلكترونية',
  filter: 'تصفية',
  search: 'اكتب هنا للبحث',
  titelSearch: 'تصفية نتائج البحث',
  choose: 'اختر',
  saudiCountry: 'المملكة العربية السعودية',
  moj: 'وزاره العدل',
  executionAgent: 'وكالة الوزارة لشؤون الحجز والتنفيذ',
  announce: 'تعلن',
  closingWord: 'والله الموفق .',
  view: 'عرض',
  cancel: 'إلغاء',
  ok: 'تأكيد',
  reset: 'اعادة ضبط',
  morning: 'صباحا',
  evening: 'مساءا',
  noData: 'لا توجد بيانات  ',
  requestInfo: 'تفاصيل الطلب',
  atTime: 'الساعة',
  noMazadatFound: 'لا توجد اعلانات عن مزادات ',
  noEasarFound: 'لا توجد طلبات اعسار ',
  noMoneyReservationFound: 'لا توجد محاضر حجز على الأموال ',
  noProvenEasaratFound: 'لا توجد طلبات الإعسار المثبته ',
  SUNDAY: 'الاحد',
  MONDAY: 'الاثنين',
  TUESDAY: 'الثلاثاء',
  WEDNESDAY: 'الاربعاء',
  THURSDAY: 'الخميس',
  FRIDAY: 'الجمعه',
  SATURDAY: 'السبت',
  breadcrumb: {
    landing: 'الرئيسية',
    home: 'الرئيسية',
    dashboard: 'لوحة المعلومات',
    mazadat: 'الاعلان عن مزادات',
    mazadDetails: 'تفاصيل الإعلان',
    easar: 'طلبات الاعسار',
    easarDetails: 'تفاصيل الطلب',
    eServices: 'الخدمات الإلكترونيه',
    provenEasarat: 'طلبات الإعسار المثبته',
    moneyReservation: 'محاضر الحجز على الأموال',
    moneyReservationDetails: 'تفاصيل الطلب ',
  },
  mazadat: {
    auctionAnnouncement: 'إعلان مزاد',
    notRealEstateForOneHundredThousandOrLess: 'غير عقار بمائة الف ريال فأقل',
    notRealEstateMoreThanOneHundredThousand: 'غير عقار بأكثر من مائة الف ريال',
    realEstateForOneHundredThousandOrLess: 'عقار بمائة الف ريال فأقل',
    realEstateMoreThanOneHundredThousand: 'عقار بأكثر من مائة الف ريال',
    requestId: 'رقم الطلب',
    mazadId: 'رقم المزاد',
    hijriDate: 'تاريخ المزاد',
    court: 'دائرة التنفيذ',
    announcingAuctions: 'الإعلان عن المزادات',
  },
  mazadInfo: {
    notRealEstateForOneHundredThousandOrLess: 'اعلان مزاد غير عقار بمائة الف ريال فأقل للمره الأولى',
    notRealEstateMoreThanOneHundredThousand: 'اعلان مزاد غير عقار بأكثر من مائة الف ريال للمره الأولى',
    realEstateForOneHundredThousandOrLess: 'اعلان مزاد عقار بمائة الف ريال فأقل للمره الأولى',
    realEstateMoreThanOneHundredThousand: 'اعلان مزاد عقار بأكثر من مائة الف ريال للمره الأولى',
    mazadDay: 'عن اقامة مزاد فى يوم',
    dayMeets: 'الموافق',
    time: 'الساعه',
    location: 'وذلك فى',
    toSell: 'لبيع',
    order: 'وقد صدر أمرنا رقم',
    orderDate: 'بتاريخ',
    conclusion: 'ببيع هذا العقار كما أنه في حال رسو المزاد فإنه يسقط خيار المجلس فمن له الرغبة بدخول المزاد ممن تاهل لدخوله و أثبت ملاءته للدخول فيه التقدم لنا للتحقق التـأهل و اثبات ملائته قبل التاريخ المحدد للمزاد وفقا للمادة 49 ولوائحها من نظام التنفيذ .',
  },
  easar: {
    easarNumber: 'رقم الطلب',
    requestSource: 'مصدر الطلب',
    requesterName: 'اسم طالب الإعسار',
    announce: 'إعلان طلب إعسار',
    asked: 'انه تقدم لها',
    nationality: 'جنسيته',
    withIdentity: 'بموجب',
    claimDetails: 'مدعيا اعساره عن دفع المبالغ الثابته بذمته فى مواجهة كل من:',
    againstName: 'الاسم',
    againstNationality: 'الجنسية',
    number: 'رقم',
    askForConfirm: 'طالبا اثبات ذلك وقد حدد يوم',
    dayMeets: 'الموافق',
    time: 'الساعه',
    claimClosingWord: 'موعدا لنظر دعواه فمن له معارضة فعليه التقدم لنا بذلك فى الموعد المحدد',
    individuals: 'الأفراد',
    corporates: 'الشركات والمؤسسات',
    decisionNumber: 'رقم الصك',
    decisionDate: 'تاريخ الصك',
    court: 'المحكمة',
    name: 'اسم المعسر',
    identityNumber: 'رقم هوية المعسر',
  },
  moneyReservation: {
    requestNumber: 'رقم الطلب',
    requestNumberDetails: 'رقم الطلب :',
    reservationNumber: 'رقم المحضر',
    reservationNumberDetails: 'رقم المحضر : ',
    reserverName: 'طالب التنفيذ  ',
    secondPartyName: 'المنفذ ضده : ',
    wakeelName: 'الوكيل : ',
    reservationDate: 'تاريخ المحضر',
    announce: 'محضر الحجز على الاموال',
    qararNo: 'رقم القرار',
    qararNoDetails: 'رقم القرار : ',
    qararDate: 'تاريخ القرار',
    qararDateDetails: 'تاريخ القرار : ',
    title: 'الموضوع : ',
    nationality: 'الجنسية : ',
    identityType: 'نوع الهوية  : ',
    identityNo: 'رقم الهوية : ',
    description: 'طلبات الحجز على الأموال',
  },
  reserveFunds: {
    title: 'بيانات المال المحجوز عليه ( غير العقار )',
    description: 'الوصف المال المحجوز عليه ',
    quantity: 'مقدراه ',
    weight: 'وزنه',
    type: 'نوعه',
    count: 'عدده',
    price: 'قيمته المقدرة',
    location: 'مكانه',
    certificate: 'مستند تملكه',
    attributes: 'صفاته',
  },
  reserveRealEstate: {
    title: 'بيانات المال المحجوز عليه (العقار) : ',
    deedNo: 'رقم صك الملكية ',
    deedDate: 'تاريخه ',
    deedLocation: 'موقعه ',
    northBorderLength: 'طول الحد الشمالي ',
    southBorderLength: ' طول الحد الجنوبي',
    eastBorderLength: 'طول الحد الشرقي ',
    westBorderLength: 'طول الحد الغربي ',
    northBorderDetails: 'وصف الحد الشمالي ',
    southBorderDetails: 'وصف الحد الجنوبي ',
    eastBorderDetails: 'وصف الحد الشرقي ',
    westBorderDetails: 'وصف الحد الغربي',
    price: 'قيمته المقدرة ',
    area: 'مساحته ',
    from: 'مصدره ',
  },
  wakeel: {
    title: 'بيانات الحارس ووكيل البيع وموعده : ',
    wakeelName: 'اسم الوكيل ',
    watchmanName: 'اسم الحارس ',
    saleDate: 'تاريخ ',
    salePlace: 'مكان البيع ',
    saleTime: 'موعد البيع',
  },

  serverErrors: {
    NOT_FOUND: 'لا يمكننا خدمتك في الوقت الحالي. الرجاء المحاولة لاحقاً',
    SERVER_ERROR: 'حدث خطأ في النظام الرجاء المحاولة لاحقاً',
    USER_NOT_FOUND: 'المستخدم غير موجود الرجاء المحاولة مرة أخرى',
  },
  months: {
    gregorian: {
      january: 'يناير',
      february: 'فبراير',
      march: 'مارس',
      april: 'أبريل',
      may: 'مايو',
      june: 'يونيو ',
      july: 'يوليو ',
      august: 'أغسطس',
      september: 'سبتمبر',
      october: 'أكتوبر',
      november: 'نوفمبر',
      december: 'ديسمبر',
    },
  },
};

export default ar;
